module.exports = __webpack_public_path__ + "img/icon-picup.3249e950.svg";